  var tsuburayaLoginForm = $('#customer_login');
  var appProxyPath = '/tools/tsuburaya/auth-v3';

$(function(){

  tsuburayaLoginForm.removeAttr('action');

  $('#loginRegisterCheck').click(function(){
    $( '.js-loading' ).show();//ローディング画像を表示
    
    if(!RegisterCheckExcute(2)){
      $( '.js-loading' ).hide();//ローディング画像を非表示
      return false;
    }
    return true;
  })

  $('#loginCheck').click(function(){
    $( '.js-loading' ).show();//ローディング画像を表示
    
    if(!RegisterCheckExcute(1)){
      $( '.js-loading' ).hide();//ローディング画像を非表示
      return false;
    }
    return true;
  })

  function RegisterCheckExcute(procDiv){
    var hostUrl= appProxyPath;
    var returnPath = "https://store.m-78.jp/"; //デフォルトのログイン後戻り先
    var procDiv = procDiv;
    
    // リファラURL
    var referrerUrl = document.referrer;
    referrerUrl = removeParams(referrerUrl, ['utm_source', 'utm_medium','utm_campaign']);
    
    // 特定URL
    var particularUrl = "https://store.m-78.jp/account/login?";
    var particularParam = "param=param"
    var checkUrl = particularUrl + particularParam;
    var t = "4"; //デフォルトを4に設定
    var i = "";

    if(referrerUrl && referrerUrl.indexOf("404") === -1){//リファラが出来る場合は戻り先に設定
      returnPath = referrerUrl
    }

    // リファラのURLと特定のURL+パラメータが一致した場合、tとiに任意の値を設定
    if (referrerUrl == checkUrl){
      t = "5";
      i = ""; //流入経路を設定
    }

    $.ajax({
        url: hostUrl,
        type: 'POST',
        data: {procDiv: procDiv, path: returnPath, t: t, i: i },
        timeout:30000,
    }).done(function(data) {
      	  if(data.result){
		if(data.status == 'success'){
		  window.location.href = data.result;
		}else{
		  $( '.js-loading' ).hide();//ローディング画像を非表示
		  alert(data.result);
		}
	  }

      // if(data.result){
      //   if(data.status == 'success'){
      //       alert(data.result);
      //   }else{
      //       $( '.js-loading' ).hide();//ローディング画像を非表示
      //       alert(data.result);
      //   }
      // }

    }).fail(function(XMLHttpRequest, textStatus, errorThrown) {
                     alert("ログインに失敗しました。時間をあけて再度お試しください");
    })
  }


  
});
  function removeParams(url, paramsToRemove) {
    var urlObj = new URL(url);
    paramsToRemove.forEach(param => urlObj.searchParams.delete(param));
    return urlObj.toString();
  }
